"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var ux_assets_1 = require("@lifesize/ux-assets");
function randomize(value) {
    if (value === void 0) { value = 0; }
    var randomVariance = Math.floor(Math.random() * (20 - 10) + 10);
    var result = Math.random() > 0.5 ? value - randomVariance : value + randomVariance;
    return Math.round((Math.min(Math.max(result, 0), 127) / 127) * 100);
}
var useStyles = core_1.makeStyles(function () { return ({
    audioIndicatorContainer: {
        height: '18px',
        display: 'flex',
        zIndex: 30,
        alignItems: 'center'
    },
    audioIndicatorBar: {
        width: '1px',
        background: ux_assets_1.colors.concrete,
        zIndex: 30,
        margin: '1px'
    }
}); });
var defaultState = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
function AudioLevelIndicator(props) {
    var classes = useStyles();
    var _a = react_1.useState(defaultState), audioLevels = _a[0], setAudioLevels = _a[1];
    var _b = props.audioLevel, audioLevel = _b === void 0 ? 0 : _b, id = props.id;
    react_1.useEffect(function () {
        var interval = setInterval(function () {
            var newAudioLevels = audioLevels.concat([randomize(audioLevel)]).slice(-10);
            return setAudioLevels(newAudioLevels);
        }, 100);
        return function cleanUp() {
            clearInterval(interval);
        };
    });
    return (react_1.default.createElement("div", { "data-testid": "audio-level", className: classes.audioIndicatorContainer }, audioLevels.map(function (l, i) { return (react_1.default.createElement("div", { key: "audioindicator-" + id + "-" + i, className: classes.audioIndicatorBar, style: { height: l > 5 ? l + "%" : '1px' } })); })));
}
exports.default = AudioLevelIndicator;
